/* eslint-disable camelcase */
/* eslint-disable no-useless-escape */
import * as Yup from 'yup';

export const getValidationSchema = () =>
  Yup.object({
    email: Yup.string().email().required('Please fill out the rest fields. This is mandatory.'),
  });
